// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleContent-module--container--3Ff9h","article":"ArticleContent-module--article--3oZSp"};